export default __webpack_public_path__ + "static/media/lossless-minter-icon.718ac40d.svg";